<template>
  <el-container class="app-container">
    <!-- Header -->
    <el-header class="header">
      <el-row class="header-container" align="middle">
        <!-- 左侧 Logo -->
        <el-col
          :xs="12"
          :sm="6"
          class="logo-container"
          style="position: relative"
        >
          <img src="@/assets/logo.jpg" alt="Logo" class="logo-image" />
          <div
            class="logo"
            style="
              position: absolute;
              left: 60px;
              top: 10px;
              width: 250px;
              font-size: 14px;
            "
          >
          SEIEI-ITN Co., Ltd
          </div>
          <div
            class="logo"
            style="
              position: absolute;
              left: 60px;
              top: 30px;
              width: 250px;
              font-size: 14px;
            "
          >
            株式会社盛栄国際
          </div>
        </el-col>

        <!-- 右侧导航菜单 -->
        <el-col :xs="0" :sm="18" class="menu-container">
          <div class="menu">
            <a href="/" class="menu-item" @click.prevent="navigateTo('/')">{{
              $t("home")
            }}</a>
            <a
              href="/company-info"
              class="menu-item"
              @click.prevent="navigateTo('/company-info')"
              >{{ $t("compamyInfo") }}</a
            >

            <el-dropdown
              @command="handleSalesChange"
              :hide-on-click="false"
              style="height: 60px"
              placement="bottom-start"
              :popper-options="{
                modifiers: [{ name: 'offset', options: { offset: [0, 0] } }],
              }"
            >
              <span
                class="el-dropdown-link"
                style="min-width: 80px; width: 90px; text-align: center"
              >
                {{ $t("services") }}
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="/usedCarsSales">{{
                    $t("usedCarsSales")
                  }}</el-dropdown-item>
                  <el-dropdown-item command="/autoPartsSales">{{
                    $t("autoPartsSales")
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>

            <a
              href="/contact"
              class="menu-item"
              @click.prevent="navigateTo('/contact')"
              >{{ $t("contact") }}</a
            >
            <el-dropdown
              @command="handleLanguageChange"
              class="language-dropdown"
              style="height: 60px"
              :popper-options="{
                modifiers: [{ name: 'offset', options: { offset: [0, 0] } }],
              }"
            >
              <span
                class="el-dropdown-link"
                style="min-width: 80px; width: 90px; text-align: center"
              >
                {{ currentLanguage }} <i class="el-icon-arrow-down"></i>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="en">English</el-dropdown-item>
                  <el-dropdown-item command="ja">日本語</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </el-col>

        <!-- 手机端汉堡菜单 -->
        <el-col :xs="12" :sm="0" class="mobile-menu-container">
          <!-- 手机端菜单图标 -->
          <el-icon
            @click="drawer = true"
            style="cursor: pointer; font-size: 25px; color: #444444"
          >
            <Menu />
          </el-icon>

          <!-- 抽屉 -->
          <el-drawer
            title="Menu"
            v-model="drawer"
            direction="rtl"
            :with-header="false"
            custom-class="mobile-drawer"
            size="70%"
          >
            <div class="drawer-header" style="position: relative">
              <img
                src="@/assets/logo.jpg"
                alt="Logo"
                class="logo-image"
                style="border-radius: 5px"
              />
              <div
                class="logo"
                style="
                  position: absolute;
                  left: 60px;
                  top: 10px;
                  width: 150px;
                  font-size: 14px;
                  color: #444444;
                "
              >
                SEIEI-INT
              </div>
            </div>
            <el-divider style="margin-top: 10px; margin-bottom: 5px" />
            <el-row gutter="20" class="drawer-menu">
              <el-col
                :span="24"
                class="drawer-menu-item"
                @click="navigateTo2('/')"
                style="cursor: pointer"
                :class="{ active: isActive('/') }"
              >
                {{ $t("home") }}
              </el-col>
              <el-col
                :span="24"
                class="drawer-menu-item"
                @click="navigateTo2('/company-info')"
                :class="{ active: isActive('/company-info') }"
                style="cursor: pointer"
              >
                {{ $t("compamyInfo") }}
              </el-col>
              <el-col
                :span="24"
                class="drawer-menu-item"
                @click="navigateTo2('/usedCarsSales')"
                :class="{ active: isActive('/usedCarsSales') }"
                style="cursor: pointer"
              >
                {{ $t("usedCarsSales") }}
              </el-col>
              <el-col
                :span="24"
                class="drawer-menu-item"
                @click="navigateTo2('/autoPartsSales')"
                :class="{ active: isActive('/autoPartsSales') }"
                style="cursor: pointer"
              >
                {{ $t("autoPartsSales") }}
              </el-col>
              <el-col
                :span="24"
                class="drawer-menu-item"
                @click="navigateTo2('/contact')"
                :class="{ active: isActive('/contact') }"
                style="cursor: pointer"
              >
                {{ $t("contact") }}
              </el-col>

              <el-divider content-position="left">语言/Language</el-divider>

              <el-col
                :span="24"
                class="drawer-menu-item"
                @click="handleMobileMenu('en')"
                :class="{ active: isActive2('en') }"
                style="cursor: pointer"
              >
                English
              </el-col>
              <el-col
                :span="24"
                class="drawer-menu-item"
                @click="handleMobileMenu('ja')"
                :class="{ active: isActive2('ja') }"
                style="cursor: pointer"
              >
                日本語
              </el-col>
            </el-row>
          </el-drawer>
        </el-col>
      </el-row>
    </el-header>

    <!-- Main Content -->
    <el-main>
      <router-view v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" v-if="$route.meta.keepAlive" />
        </keep-alive>
        <component :is="Component" v-if="!$route.meta.keepAlive" />
      </router-view>
    </el-main>

    <!-- Footer -->
    <el-footer class="footer">
      <el-row justify="center">
        <el-col :span="24"
          >Copyright © 2025 株式会社盛栄国際 (SEIEI-ITN)
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { Menu } from "@element-plus/icons-vue"; // 引入 Element Plus 图标库中的 Menu 图标
import { useI18n } from "vue-i18n";

export default {
  components: {
    Menu,
  },
  setup() {
    const { locale } = useI18n();
    const drawer = ref(false); // 控制抽屉显示
    const currentLanguage = ref("English");
    const router = useRouter();

    // PC模式下页面跳转
    const navigateTo = (path) => {
      router.push(path);
    };
    // 手机模式 页面跳转
    const navigateTo2 = (path) => {
      drawer.value = false; // 关闭抽屉
      router.push(path);
    };

    // サービス遷移
    const handleSalesChange = (path) => {
      router.push(path);
    };

    const handleLanguageChange = (language) => {
      if (language === "en") currentLanguage.value = "English";
      else if (language === "ja") currentLanguage.value = "日本語";
      else if (language === "zh") currentLanguage.value = "中文";
      locale.value = language; // 切换语言
    };

    const handleMobileMenu = (language) => {
      if (language === "en") currentLanguage.value = "English";
      else if (language === "ja") currentLanguage.value = "日本語";
      else if (language === "zh") currentLanguage.value = "中文";
      locale.value = language; // 切换语言
      drawer.value = false; // 关闭抽屉
    };

    const isActive = (path) => {
      return router.currentRoute.value.path === path;
    };

    const isActive2 = (language) => {
      return locale.value === language;
    };

    return {
      drawer,
      currentLanguage,
      navigateTo,
      navigateTo2,
      handleSalesChange,
      handleLanguageChange,
      handleMobileMenu,
      isActive,
      isActive2,
    };
  },
};
</script>

<style scoped>
.header {
  /* background: linear-gradient(to right, #46474b, #2b85b6); */
  background: white;
  padding: 0 20px;
  color: #444444;
  height: 60px;
  position: sticky;
  z-index: 1000;
  top: 0px;
}

.header::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: #f2f3f5; /* 蓝色装饰条 3dbaea*/
}

.header-container {
  width: 100%;
  display: flex;
  justify-content: space-between; /* 左右对齐 */
  align-items: center; /* 垂直居中 */
  height: 100%;
}

.logo-container {
  display: flex;
  align-items: center; /* Logo 垂直居中 */
  height: 100%;
}

.logo-image {
  width: 45px;
}

.menu-container {
  display: flex;
  justify-content: flex-end; /* 菜单右对齐 */
  align-items: center;
}

.mobile-menu-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

/* 手机端隐藏菜单 */
@media (max-width: 768px) {
  .menu-container {
    display: none;
  }
}

/* PC端隐藏手机菜单 */
@media (min-width: 769px) {
  .mobile-menu-container {
    display: none;
  }
}

.menu {
  display: flex;
  align-items: center;
  gap: 20px;
  height: 60px; /* 设置与蓝色背景一致的高度 */
}

.menu-item {
  color: #444444;
  text-decoration: none;
  font-size: 16px;
  text-align: center;
  transition: all 0.3s;
  height: 100%; /* 高度与父容器一致 */
  display: flex; /* 确保内容垂直居中 */
  align-items: center; /* 文字垂直居中 */
  justify-content: center; /* 文字水平居中 */
  padding: 0 15px; /* 左右内边距 */
  background-color: transparent; /* 默认透明背景 */
  border-radius: 0; /* 移除圆角 */
  min-width: 80px;
  width: 90px;
}

.menu-item:hover {
  color: #369dcc; /* 鼠标悬停时文字变蓝 369dcc*/
  font-weight: bold;
  background-color: none; /* 鼠标悬停时背景变白 */
}

.language-dropdown {
  color: #444444;
  font-size: 16px;
  cursor: pointer;
}

.language-dropdown:hover {
  color: #369dcc;
}

/* Footer 样式 */
.footer {
  text-align: center;
  /* background: linear-gradient(to right, #46474b, #2b85b6); */
  background: black;
  color: white;
  padding: 10px 0;
  font-size: 14px;
  height: 40px;
}

.el-dropdown-link {
  color: #444444;
  text-decoration: none;
  font-size: 16px;
  text-align: center;
  transition: all 0.3s;
  height: 100%; /* 高度与父容器一致 */
  display: flex; /* 确保内容垂直居中 */
  align-items: center; /* 文字垂直居中 */
  justify-content: center; /* 文字水平居中 */
  padding: 0 15px; /* 左右内边距 */
  background-color: transparent; /* 默认透明背景 */
  border-radius: 0; /* 移除圆角 */
}

.el-dropdown-link:hover {
  color: #369dcc; /* 鼠标悬停时文字变蓝 369dcc*/
  font-weight: bold;
  background-color: white; /* 鼠标悬停时背景变白 */
}

.drawer-menu-item {
  font-size: 18px;
  color: #2c3e50;
  padding: 10px 10px 10px 10px;
  background-color: rgb(255, 255, 255);
}

.el-dropdown-menu {
  width: 150px;
  /* background-color: #2d85b5; */
  background-color: white;
  border-radius: 0px;
  margin: 0;
}

/* 激活状态 */
.drawer-menu-item.active {
  /* font-weight: bold; */
  /* color: #2d85b5; */
  color: #444444;
  /* background-color: #bedff1; */
  background: linear-gradient(90deg, #e7f1f4 0%, #f0f3f4 100%);
  border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
}

:global(.el-dropdown-menu__item) {
  font-size: 14px !important;
  color: #444444 !important;
  line-height: 40px !important;
}

:global(.el-dropdown-menu__item:hover) {
  /* background-color: #fff !important; */
  color: #369dcc !important;
  font-weight: bold;
}

:global(.el-popper__arrow) {
  display: none !important;
}

:global(.el-popper) {
  border-radius: 0px !important;
}

:focus-visible {
  outline: none;
}
</style>
